import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useCart } from "../context/CartContext";
import "./Navbar.css";

const Navbar = () => {
  const { isAuthenticated, user, logout } = useAuth();
  const { cartCount } = useCart();
  const navigate = useNavigate();
  const location = useLocation();
  const [showDropdown, setShowDropdown] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  // Pages with bright backgrounds need dark navbar even when not scrolled
  const brightPages = ["/about", "/products", "/products/biscuits", "/register", "/login", "/admin/orders", "/cart", "/checkout", "/orders"];
  const forceDarkPrefix = ["/products/", "/order-success/"];
  const forceDark = brightPages.includes(location.pathname) ||
    forceDarkPrefix.some((prefix) => location.pathname.startsWith(prefix));
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleLogout = () => {
    logout();
    setShowDropdown(false);
    navigate("/");
  };

  const handleSearch = (e) => {
    e.preventDefault();
    // search handler placeholder
  };

  return (
    <nav className={`navbar ${(scrolled || forceDark) ? "navbar-scrolled" : "navbar-transparent"}`}>
      <Link to="/" className="logo">
        <img src="https://storage.googleapis.com/rasai-nutrie-assets/images/logo.png" alt="RASAI nutrie" className="logo-img" />
      </Link>
      <ul className="nav-links">
        <li><Link to="/">Home</Link></li>
        <li><Link to="/about">About Us</Link></li>
        <li><Link to="/products">Products</Link></li>
        <li><Link to="/blog">Blog</Link></li>
      </ul>
      <div className="nav-right">
        <form className="search-bar" onSubmit={handleSearch}>
          <input
            type="text"
            placeholder="Search"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          <button type="submit" className="search-icon" aria-label="Search">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="11" cy="11" r="8" />
              <line x1="21" y1="21" x2="16.65" y2="16.65" />
            </svg>
          </button>
        </form>
        <Link to="/cart" className="cart-icon" aria-label="Cart">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/>
            <line x1="3" y1="6" x2="21" y2="6"/>
            <path d="M16 10a4 4 0 01-8 0"/>
          </svg>
          {cartCount > 0 && <span className="cart-badge">{cartCount}</span>}
        </Link>
        <div className="nav-auth">
        {isAuthenticated ? (
          <div className="user-menu">
            <button
              className="user-button"
              onClick={() => setShowDropdown(!showDropdown)}
            >
              <span className="user-avatar">
                {user?.full_name?.charAt(0).toUpperCase()}
              </span>
              <span className="user-name">{user?.full_name?.split(" ")[0]}</span>
            </button>
            {showDropdown && (
              <div className="dropdown-menu">
                <div className="dropdown-header">
                  <p className="dropdown-name">{user?.full_name}</p>
                  <p className="dropdown-email">{user?.email}</p>
                </div>
                <div className="dropdown-divider"></div>
                <button className="dropdown-item" onClick={() => navigate("/profile")}>
                  My Profile
                </button>
                <button className="dropdown-item" onClick={() => { navigate("/orders"); setShowDropdown(false); }}>
                  My Orders
                </button>
                {user?.is_admin && (
                  <button className="dropdown-item admin-item" onClick={() => { navigate("/admin/orders"); setShowDropdown(false); }}>
                    Admin: All Orders
                  </button>
                )}
                <div className="dropdown-divider"></div>
                <button className="dropdown-item logout" onClick={handleLogout}>
                  Logout
                </button>
              </div>
            )}
          </div>
        ) : (
          <Link to="/login" className="login-btn">
            Login
          </Link>
        )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
